import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, LogOut, X } from 'lucide-react';

const MobileMenu = ({ isOpen, onClose, user, navigation, recruiterNavigation, adminNavigation, onLogout }) => {
  const location = useLocation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] lg:hidden">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[101]" 
        onClick={onClose}
      />
      
      {/* Menu - FUNDO TOTALMENTE OPACO */}
      <div 
        className="fixed inset-y-0 right-0 w-80 max-w-[90vw] shadow-2xl z-[102] animate-slide-left mobile-menu-bg"
        style={{ backgroundColor: 'rgb(15, 23, 42)', opacity: 1 }}
      >
        <div className="flex flex-col h-screen" style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-white/10 flex-shrink-0">
            <div className="flex items-center space-x-3">
              <div className="relative flex-shrink-0">
                <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl blur-lg opacity-50"></div>
                <div className="relative w-10 h-10 rounded-xl flex items-center justify-center shadow-lg overflow-hidden">
                  <img 
                    src="/logo.jfif" 
                    alt="Revolution Logo" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="font-bold text-white truncate">Revolution</h2>
                <p className="text-sm text-gray-400 truncate">Olá, {user?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-xl text-gray-400 hover:text-white hover:bg-white/10 transition-all duration-200 flex-shrink-0"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Navigation */}
          <div className="flex-1 overflow-y-auto py-4">
            <div className="px-4 space-y-1">
              {/* Main Navigation */}
              {navigation && navigation.length > 0 ? (
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
                    Principal
                  </h3>
                  <div className="space-y-1">
                    {navigation.map((item) => {
                      const Icon = item.icon;
                      const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                      return (
                        <Link
                          key={item.name}
                          to={item.href}
                          onClick={onClose}
                          className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                            isActive
                              ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-semibold shadow-lg'
                              : 'text-gray-300 hover:bg-white/10 hover:text-white'
                          }`}
                        >
                          <Icon className="w-5 h-5 flex-shrink-0" />
                          <span className="flex-1">{item.name}</span>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="mb-4 px-3 py-8 text-center">
                  <p className="text-gray-400 text-sm">Nenhuma navegação disponível</p>
                  <p className="text-gray-500 text-xs mt-2">Verifique o console</p>
                </div>
              )}

              {/* Recruiter Navigation */}
              {recruiterNavigation && recruiterNavigation.length > 0 && (
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
                    Recrutamento
                  </h3>
                  <div className="space-y-1">
                    {recruiterNavigation.map((item) => {
                      const Icon = item.icon;
                      const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                      return (
                        <Link
                          key={item.name}
                          to={item.href}
                          onClick={onClose}
                          className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                            isActive
                              ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold shadow-lg'
                              : 'text-gray-300 hover:bg-white/10 hover:text-white'
                          }`}
                        >
                          <Icon className="w-5 h-5 flex-shrink-0" />
                          <span className="flex-1">{item.name}</span>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Admin Navigation */}
              {adminNavigation && adminNavigation.length > 0 && (
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
                    Administração
                  </h3>
                  <div className="space-y-1">
                    {adminNavigation.map((item) => {
                      const Icon = item.icon;
                      const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                      return (
                        <Link
                          key={item.name}
                          to={item.href}
                          onClick={onClose}
                          className={`flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                            isActive
                              ? 'bg-gradient-to-r from-purple-500 to-pink-600 text-white font-semibold shadow-lg'
                              : 'text-gray-300 hover:bg-white/10 hover:text-white'
                          }`}
                        >
                          <Icon className="w-5 h-5 flex-shrink-0" />
                          <span className="flex-1">{item.name}</span>
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* User Actions */}
              <div className="mb-4">
                <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
                  Conta
                </h3>
                <div className="space-y-1">
                  <Link
                    to="/app/profile"
                    onClick={onClose}
                    className="flex items-center space-x-3 px-3 py-2.5 rounded-lg text-gray-300 hover:bg-white/10 hover:text-white transition-all duration-200"
                  >
                    <User className="w-5 h-5 flex-shrink-0" />
                    <span className="flex-1">Meu Perfil</span>
                  </Link>
                  <button
                    onClick={() => {
                      onLogout();
                      onClose();
                    }}
                    className="flex items-center space-x-3 px-3 py-2.5 rounded-lg text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-all duration-200 w-full text-left"
                  >
                    <LogOut className="w-5 h-5 flex-shrink-0" />
                    <span className="flex-1">Sair</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-white/10 flex-shrink-0">
            <div className="text-center text-xs text-gray-400">
              <p className="font-semibold text-gray-300">Revolution v1.0</p>
              <p className="mt-1">© 2025 Todos os direitos reservados</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;